import { AccountSupervisorCircleIcon } from './AccountSupervisorCircleIcon';

/**
 * author: Google
 * id 741E5459-89DC-4045-B02E-3FB74F636143
 * name account-supervisor-circle
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-supervisor-circle.svg
 * tags
 * - Account / User 
 */
export const PersonSupervisorCircleIcon = AccountSupervisorCircleIcon;
export default PersonSupervisorCircleIcon